"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPermissionInFeature = exports.restrictUserPermissions = exports.mapOrganisationAccessToPermission = void 0;

var _permissions = require("../constants/permissions");

/**
 * Convert API Roles into permissions
 */
var mapOrganisationAccessToPermission = function mapOrganisationAccessToPermission(hasAccess, isInternalUser, isAccountManager) {
  if (isInternalUser === void 0) {
    isInternalUser = false;
  }

  if (isAccountManager === void 0) {
    isAccountManager = false;
  }

  // Internal Admin
  if (hasAccess && isInternalUser) {
    return _permissions.permissions.INTERNAL_ADMIN;
  } // Account Manager Admin


  if (hasAccess && isAccountManager) {
    return _permissions.permissions.ACCOUNT_MANAGER_ADMIN;
  } // Standard User


  if (hasAccess) {
    return _permissions.permissions.STANDARD_USER;
  }

  return _permissions.permissions.NO_ACCESS;
};

exports.mapOrganisationAccessToPermission = mapOrganisationAccessToPermission;

var restrictUserPermissions = function restrictUserPermissions(allowedPermissions, userPermission) {
  return allowedPermissions.includes(userPermission) || false;
};

exports.restrictUserPermissions = restrictUserPermissions;

var getPermissionInFeature = function getPermissionInFeature(featureId, auth) {
  if (!auth) {
    return null;
  }

  return auth[featureId] ? auth[featureId].permission : _permissions.permissions.NO_ACCESS;
};

exports.getPermissionInFeature = getPermissionInFeature;